import React from "react";
import aboutUsImg from "./bg/AboutUs.png";
import whyChooseUsImg from "./bg/whyChooseUs.png";

export const Features = () => {
  return (
    <div id="aboutus" className="container-fluid py-5" style={{ backgroundColor: "#fff" }}>
      <div className="container">
        
        {/* About Us Section */}
        <div className="row align-items-center mb-5">
        <h3 className="text-center mb-4" style={{ fontWeight: "bold" }}>
          About Us
        </h3>
          <div className="col-12">
            <img 
              src={aboutUsImg} 
              alt="About Us" 
              className="img-fluid"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "8px",
                display: "block",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
              }} 
            />
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div className="row align-items-center">
        <h3 className="text-center mb-4" style={{ fontWeight: "bold" }}>
          Why Choose Us?
        </h3>
          <div className="col-12">
            <img 
              src={whyChooseUsImg} 
              alt="Why Choose Us" 
              className="img-fluid"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "8px",
                display: "block",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
              }} 
            />
          </div>
        </div>
        
      </div>
    </div>
  );
};
